import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '../icon/icon.module';
import { AppTooltipModule } from '../tooltip/tooltip.module';

import { ButtonDirective } from './button.directive';
import { CircleButtonDirective } from './circle-button/circle-button.directive';
import { TabButtonDirective } from './tab-button.directive';
import { CircleButtonComponent } from './circle-button/circle-button.component';
import { PlusButtonComponent } from './plus-button/plus-button.component';
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { QuestionButtonComponent } from './question-button/question-button.component';
import { PaginationButtonComponent } from './pagination-button/pagination-button.component';
import { TooltipIconButtonComponent } from './tooltip-icon-button/tooltip-icon-button.component';
import { DashedCollapseBtnComponent } from './dashed-collapse-btn/dashed-collapse-btn.component';


@NgModule({
  imports: [CommonModule, IconModule, AppTooltipModule],
  declarations: [
    ButtonDirective,
    CircleButtonComponent,
    CircleButtonDirective,
    TabButtonDirective,
    PlusButtonComponent,
    DeleteButtonComponent,
    ToggleButtonComponent,
    QuestionButtonComponent,
    PaginationButtonComponent,
    TooltipIconButtonComponent,
    DashedCollapseBtnComponent,
  ],
  exports: [
    ButtonDirective,
    CircleButtonComponent,
    CircleButtonDirective,
    TabButtonDirective,
    PlusButtonComponent,
    DeleteButtonComponent,
    ToggleButtonComponent,
    QuestionButtonComponent,
    PaginationButtonComponent,
    TooltipIconButtonComponent,
    DashedCollapseBtnComponent,
   ],
  providers: []
})
export class ButtonModule { }
